import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';

function phoneNumberValidator(): ValidatorFn {
  return (form: FormGroup): ValidationErrors | null => {
    const preferredContactMethod = form.get('preferredContactMethod');

    if (preferredContactMethod?.value === 'Alternate Phone') {
      const countryCode = form.get('countryCode').value;
      const phoneNumber = form.get('alternatePhone').value;

      if (countryCode !== '' && phoneNumber !== '') {
        if (!isValidPhoneNumber(phoneNumber, countryCode as CountryCode)) {
          return { isValidPhoneNumber: true };
        }
      }
    }
    return null;
  };
}

export { phoneNumberValidator };
